import React from 'react';
import { useAppSelector } from 'hooks';
import { Alert, Collapse } from 'reactstrap';

import { InputProps } from '~components/form-fields';
import Icon, { faInfoCircle } from '~components/icon';

import { selectUserByID } from '~care-workers/selectors/users';

function FormInputWorkerRosterNotes({ value = {}, id }: InputProps) {
  const { user_id } = value;
  const user = useAppSelector((state) => selectUserByID(state, parseInt(user_id)));

  const notes = user?.rostering_notes;
  const isOpen = notes ? notes?.length > 0 : false;
  return (
    <Collapse isOpen={isOpen}>
      <Alert
        color="info"
        className="d-flex align-items-center justify-content-center"
        data-id={id}
        data-cy={`${id}-alert`}
      >
        <Icon className="me-2" size="2x" icon={faInfoCircle} />
        <div className="fw-bold form-notes">{notes}</div>
      </Alert>
    </Collapse>
  );
}

export default FormInputWorkerRosterNotes;
